import { Divider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import React from 'react'
import ACDDrawerBody from './ACDDrawerBody'

const ACDDrawer = ({ drawerState, handleDrawer, staff, appraisalId }) => {
  return (
    <Box>
      <AdxDrawerComponent
        state={drawerState}
        anchor="right"
        onClose={handleDrawer}
        headerprops
        title={'Participant Result'}
        noPaddingContent
      >
        <ACDDrawerBody staff={staff} appraisalId={appraisalId} />
      </AdxDrawerComponent>
    </Box>
  )
}

export default ACDDrawer
